/**
 * Scripts for an inline line (ie. normal list page in a tab using the InlinePanelField type
 */
$(document).ready(function () {

    $('.js-inline-list').each(function () {
        var container = $(this);

        // setup events on list
        setup_events(true);

        // reload event so can be triggered externally
        container.on("inline.reload", function () {
            reload_url();
        });

        // reload event so can be triggered externally
        container.on("inline.show_wait", function () {
            container.find(".please_wait").show();
        });

        function reload_url(url) {
            if (typeof url == "undefined") {
                url = container.data("url");
            } else {
                container.data('url', url);
            }

            container.find(".please_wait").show();

            container.find(".inline-content").load(url, function() {
                setup_events();
                container.find(".please_wait").hide();
            });
        }

        // main event setup, done as a function so can be re-done after a page or reload
        function setup_events(first_run) {

            // call main list event init
            if (first_run !== true) {
                admin.loaded("#" + container.attr('id'));
            }

            // pagination links - force to run through the list
            container.find("ul.pagination a").click(function (ev) {
                ev.preventDefault();

                reload_url($(this).attr('href'));
            });

            container.find("a.js-item-create").click(function (ev) {
                ev.preventDefault();
                show_modal("/inline" + $(this).attr('href'));
            });

            container.find("a.js-item-edit").click(function (ev) {
                ev.preventDefault();
                show_modal("/inline" + $(this).attr('href'));
            });

            container.find("a.js-item-delete").unbind("click");
            container.find("a.js-item-delete").click(function (ev) {
                ev.preventDefault();

                var url = "/inline" + $(this).attr('href');

                swal({
                    title: "Are you sure?",
                    text: "You may not be able to recover this item.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, delete it!",
                    closeOnConfirm: true
                }, function () {
                    // do delete
                    $.ajax({
                        url: url
                    }).done(function() {
                        reload_url();
                    }).error(function() {
                        reload_url();
                    });
                });
            });

            //inline actions
            container.find('.js-action-select-button').click(function (ev) {
                ev.preventDefault();

                if ($(this).hasClass('dropdown-toggle')){
                    //nothing do on the first click
                    return;
                }

                var action = $(this).data('action');
                var actionUrl = $(this).data('actionUrl');
                var actionParams = $(this).data('actionParams');

                var rows = [];
                container.find('.js-action-select-row:checked').each(function() {
                    rows.push($(this).val());
                });

                $.ajax({
                    url: actionUrl,
                    type : 'post',
                    data : {
                        'action' : action,
                        'action_params' : actionParams,
                        'row[]' : rows
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }).done(function() {
                    reload_url();
                }).error(function() {
                    reload_url();
                });

            });

            // sort out the orderable stuff for an inline panel
            container.find(".js-ordering-inline-list").sortable({
                handle: ".handle",
                update: function (event, ui) {
                    var container = $(this);

                    $('#js-ordering-popup').show();
                    $('#js-ordering-popup .js-ordering-save').unbind("click");
                    $('#js-ordering-popup .js-ordering-save').click(function (ev) {

                        ev.preventDefault();

                        // post the new ordering through a ajax form post

                        var data = container.find('.js-ordering-input').serialize();

                        data = data + "&_token=" + container.data("order-token");
                        data = data + "&json=1";

                        $.ajax({
                            type: "POST",
                            url: container.data("order-url"),
                            data: data, // serializes the form's elements.
                            success: function(data)
                            {
                                $('#js-ordering-popup').hide();

                                swal({
                                    title: "Ordering saved",
                                    text: "",
                                    type: "success",
                                    showCancelButton: false,
                                    confirmButtonColor: "#1ab394",
                                    confirmButtonText: "OK!",
                                    closeOnConfirm: false,
                                    timer: 2000,
                                });

                            },
                            error: function (data)
                            {
                                swal({
                                    title: "",
                                    text: "An error occurred when saving the ordering",
                                    type: "danger",
                                    showCancelButton: true,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "OK",
                                    closeOnConfirm: true
                                });
                            }
                        });
                    });
                    var orderNo = 1;
                    container.find('.js-ordering-input').each(function () {
                        $(this).val(orderNo++);
                    });
                }
            });
        }

        function setup_edit_events() {

            admin.loaded("#inline-form-modal");

            $('#inline-form-modal .js-edit-submit-button').unbind("click");
            $('#inline-form-modal .js-edit-submit-button').click(function (ev) {
                ev.preventDefault();

                $('#inline-form-iframe').unbind("load");
                $('#inline-form-iframe').load(function () {
                    try {
                        var text = $('#inline-form-iframe').contents().text();
                        if (text.indexOf("{") != 0)
                        {
                            text = text.substr(text.indexOf("{"));
                        }
                        var result = $.parseJSON(text);

                        if (result.status > 199 && result.status < 300)
                        {
                            swal({
                                title: "Item saved",
                                text: "",
                                type: "success",
                                showCancelButton: false,
                                confirmButtonColor: "#1ab394",
                                confirmButtonText: "OK!",
                                closeOnConfirm: false,
                                timer: 1000,
                            });

                            // NOTE: Buttons are disabled except "save and close"

                            if (result.action == "save")
                            {
                                // nothing to do here, we just saved

                                // TODO: if this is a create action, then we need to refresh the panel
                            } else if (result.action == "close")
                            {
                                // all good, we need to reload the panel that triggered this!
                                $('#inline-form-modal').modal("hide");
                                reload_url();
                            } else { // 'new'
                                // close the form and hit the "new" button
                                $('#inline-form-modal').modal("hide");
                                container.find("a.js-item-create").click();
                            }

                        } else {
                            admin.showError(result.errors);
                        }

                    } catch (e)
                    {
                        alert(e);
                        return;
                    }
                });

                $('#inline-form-post-type').val($(this).data('post-type'));
                $('#inline-form-form').submit();
            });
        }

        function show_modal(url) {
            $('#inline-form-modal').html($('#modal-wait-template').html());

            $('#inline-form-modal').modal();
            $('#inline-form-modal .modal-content').unbind("load");
            $('#inline-form-modal .modal-content').load(url, function (ev) {
                setup_edit_events();
            });
        }

        // trigger reload on initial page load
        reload_url();
    })
});